import React from 'react';

 function Header() {
     const logo=(<img src="http://assets.ngin.com/attachments/document/0069/9771/AC_Wings_Logo.png" alt="logo"/>);
    return (
        <div className="header">
            {logo}
            <h3>Pocket Diary</h3>
        </div>
    );
}

export default Header;
